module.exports = __webpack_public_path__ + "static/media/mbcg.e3076064.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/mbcg.png
// module id = 328
// module chunks = 0